import { render } from "./EventAutoMessageSettingView.vue?vue&type=template&id=9d4d2726&scoped=true"
import script from "./EventAutoMessageSettingView.vue?vue&type=script&lang=js"
export * from "./EventAutoMessageSettingView.vue?vue&type=script&lang=js"

import "./EventAutoMessageSettingView.vue?vue&type=style&index=0&id=9d4d2726&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d4d2726"]])

export default __exports__